
 import * as React from 'react';
 import {createComponent} from '@lit/react';
 
 import {ObiThreewayAcuatorGenericInleftLeft100 as ObiThreewayAcuatorGenericInleftLeft100Element} from '@oicl/openbridge-webcomponents/dist/icons/icon-threeway-acuator-generic-inleft-left-100.js';
 
 
 

 
 export const ObiThreewayAcuatorGenericInleftLeft100 = createComponent({
   react: React,
   tagName: 'obi-threeway-acuator-generic-inleft-left-100',
   elementClass: ObiThreewayAcuatorGenericInleftLeft100Element,
   events: {
     
   }
  });
 
 